import React from 'react';
import { Button, Tooltip, Grid } from 'antd';

// Floating Action Button : visible uniquement en mobile, ancré bas-droite.
// Usage : <MobileFab icon={<PlusOutlined />} onClick={...} title="Nouveau client" />
const MobileFab = ({ icon, onClick, title, color = '#1A2B5F' }) => {
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.sm;
    if (!isMobile) return null;

    return (
        <Tooltip title={title} placement="left">
            <Button
                type="primary"
                shape="circle"
                size="large"
                icon={icon}
                onClick={onClick}
                aria-label={title}
                style={{
                    position: 'fixed',
                    right: 20,
                    bottom: 20,
                    width: 56,
                    height: 56,
                    fontSize: 22,
                    backgroundColor: color,
                    borderColor: color,
                    boxShadow: '0 4px 16px rgba(0,0,0,0.25)',
                    zIndex: 1000,
                }}
            />
        </Tooltip>
    );
};

export default MobileFab;
